import { useMemo } from 'react'

export default (tableConfig) =>
  useMemo(
    () =>
      tableConfig.columns
        .filter(({ enableHiding = true }) => enableHiding)
        .map(({ id, header = '' }) => {
          return {
            value: id,
            label: header,
          }
        }),
    [tableConfig],
  )
